import React from 'react';

import clsx from 'clsx';

import Stack from '@gogame/ui/Stack';
import Typography from '@gogame/ui/Typography';
import { makeStyles } from '@gogame/ui/styles';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    flexShrink: 0,
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    paddingTop: theme.spacing(1.5),
    paddingBottom: theme.spacing(1.5),
    minHeight: 56,
  },
  dense: {
    paddingTop: 0,
    paddingBottom: 0,
  },
  tabs: {
    margin: '-12px  12px -12px -16px !important',
    '& button': {
      height: '64px',
    },
  },
  icon: {
    display: 'flex'
  }
}));

export const ActionBar = ({
  dense,
  tabs,
  children,
  search,
  fullScreen,
  action,
  title,
  icon,
  secondaryActions,
  primaryActions,
  modeSwitcher,
  className,
}) => {
  if (action) {
    throw new Error('Use secondary actions in ActionBar');
  }
  const classes = useStyles();

  return (
    <Stack
      component={'header'}
      direction={'row'}
      alignItems={'center'}
      className={clsx(className, classes.root, {
        [classes.dense]: dense,
      })}
      spacing={1}
    >
      {tabs ? (
        <div data-cy={'tabs'} className={classes.tabs}>
          {tabs}
        </div>
      ) : null}
      {icon ? <div data-cy={'icon'} className={classes.icon}>{icon}</div> : null}
      {title ? (
        <div data-cy={'title'}>
          <Typography variant={'subtitle1'}>{title}</Typography>
        </div>
      ) : null}
      <Stack zeroMinWidth sx={{ flexGrow: 1 }} data-cy={'children'}>
        {children}
      </Stack>
      {search ? <div data-cy={'search'}>{search}</div> : null}
      {fullScreen ? <div data-cy={'full-screen'}>{fullScreen}</div> : null}
      {secondaryActions ? (
        <div data-cy={'secondary-actions'}>{secondaryActions}</div>
      ) : null}
      {primaryActions ? (
        <div data-cy={'primary-actions'}>{primaryActions}</div>
      ) : null}
      {modeSwitcher ? <div data-cy={'switch'}>{modeSwitcher}</div> : null}
    </Stack>
  );
};
